var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWf = (_a) => {
    var { title, titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    return (_jsxs("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 100 100", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId }, props, { children: [title ? _jsx("title", { id: titleId, children: title }) : null, _jsx("path", { fill: "#BEF3F1", d: "M0 0h100v100H0z" }), _jsx("path", { d: "M58.466 45.078c-.979.537-2.535 1.996-4.333 4.009 2.267 2.289 4.862 5.245 7.661 8.993 4.411-5.906 7.303-10.032 9.392-11.561 2.091-1.531 8.86-3.512 20.782-5.519-17.924 1.619-30.829 2.618-33.502 4.078Zm-11.345.542C44.22 43.524 27.811 42.258 7 41.751c9.96 1.486 22.715 3.618 26.385 5.926 2.922 1.832 6.104 5.273 11.53 11.531l15.447.305c-5.543-7.425-10.29-11.751-13.241-13.893Z", fill: "#218365" })] })));
};
export default SvgWf;
